export const validation = {
  required: "必填字段",
  number: "必须为数字",
  numberPositive: "数字必须为正数",
  numberInteger: "数字必须为整数",
};
